import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import { polyfill } from 'react-lifecycles-compat';
import { Transition } from 'react-transition-group';

var Progress = /*#__PURE__*/function (_React$Component) {
  _inherits(Progress, _React$Component);

  var _super = _createSuper(Progress);

  function Progress() {
    var _this;

    _classCallCheck(this, Progress);

    _this = _super.apply(this, arguments); // eslint-disable-next-line react/state-in-constructor

    _this.state = {
      width: 0,
      animationStart: false,
      animationEnd: false
    };

    _this.onTransitionEnd = function () {
      _this.setState({
        animationEnd: true
      });
    };

    return _this;
  }

  _createClass(Progress, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        animationStart: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          percentage = _this$props.percentage,
          height = _this$props.height,
          animation = _this$props.animation,
          status = _this$props.status,
          showIcon = _this$props.showIcon,
          showText = _this$props.showText,
          textInside = _this$props.textInside,
          animationDuration = _this$props.animationDuration,
          color = _this$props.color,
          className = _this$props.className,
          style = _this$props.style;
      var _this$state = this.state,
          width = _this$state.width,
          animationStart = _this$state.animationStart,
          animationEnd = _this$state.animationEnd;
      var animationDurations = "".concat(animation ? animationDuration : 0, "s");
      var barOuterStyle = {};
      var innerTextStyle = {};
      var transitionStyles = {
        entering: {
          width: '0'
        },
        entered: {
          width: "".concat(width, "%")
        }
      };
      barOuterStyle.height = "".concat(height, "px");
      innerTextStyle.lineHeight = "".concat(height, "px");
      var iconEle = null;

      if (showIcon && status) {
        if (status === 'error') {
          iconEle = /*#__PURE__*/React.createElement("span", {
            className: "roo-icon roo-icon-times-circle",
            style: {
              color: '#F76C6C',
              marginLeft: 4
            }
          });
        } else if (status === 'success') {
          iconEle = /*#__PURE__*/React.createElement("span", {
            className: "roo-icon roo-icon-check-circle-o",
            style: {
              color: '#63D29D',
              marginLeft: 4
            }
          });
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        className: classNames("roo-progress ".concat(textInside ? 'text-inside' : '', " ").concat(status === 'error' ? 'is-error' : 'is-success'), className),
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-progress-bar"
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-progress-bar-outer",
        style: barOuterStyle
      }, /*#__PURE__*/React.createElement(Transition, {
        timeout: animationDuration || 2,
        onExited: this.onTransitionEnd,
        in: animationStart
      }, function (state) {
        return /*#__PURE__*/React.createElement("div", {
          className: "roo-progress-bar-inner",
          style: _Object$assign({
            backgroundColor: color,
            transitionDuration: animationDurations,
            WebkitTransitionDuration: animationDurations
          }, transitionStyles[state])
        }, showText && textInside && /*#__PURE__*/React.createElement("div", {
          className: "roo-progress-inner-text",
          style: _Object$assign({
            display: !animation || animationEnd ? 'block' : 'none'
          }, innerTextStyle)
        }, "".concat(percentage, "%")));
      }))), iconEle, showText && !textInside && /*#__PURE__*/React.createElement("div", {
        className: "roo-progress-text"
      }, "".concat(percentage, "%")));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.percentage !== prevState.width) {
        return {
          width: nextProps.percentage
        };
      }

      return null;
    }
  }]);

  return Progress;
}(React.Component);

Progress.propTypes = {
  percentage: PropTypes.number,
  showText: PropTypes.bool,
  status: PropTypes.string,
  color: PropTypes.string,
  showIcon: PropTypes.bool,
  height: PropTypes.number,
  textInside: PropTypes.bool,
  animation: PropTypes.bool,
  animationDuration: PropTypes.number
};
Progress.defaultProps = {
  percentage: 0,
  showText: false,
  status: null,
  color: '',
  showIcon: false,
  height: 6,
  textInside: false,
  animation: false,
  animationDuration: 2
}; // @ts-ignore

polyfill(Progress);
export default Progress;